import { render, staticRenderFns } from "./SectionBlocks.vue?vue&type=template&id=5f344f48&"
import script from "./SectionBlocks.vue?vue&type=script&lang=js&"
export * from "./SectionBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports